import {
  MENU_GETTERS_ENUM,
} from './menu.enum';

export const menuGetters = {
  [MENU_GETTERS_ENUM.GET_SWIPE_GESTURE](state) {
    return state.swipeGesture;
  },
};
